const host =
  window.location.hostname === 'localhost'
    ? 'dashboards.philasd.org' // change from devdashboards.philasd.org back to dashboards until SDP adopts QAP dev>test>prod env promotion
    : window.location.hostname

export default ({ app }, inject) => {
  inject('host', host)
}
